export default "__VITE_ASSET__ae0038ed__"